/*
 *
 *  This file is part of fof/drafts.
 *
 *  Copyright (c) 2019 FriendsOfFlarum.
 *
 *  For the full copyright and license information, please view the LICENSE.md
 *  file that was distributed with this source code.
 *
 */

import DraftsDropdown from './DraftsDropdown';
import DraftsList from './DraftsList';
import DraftsPage from './DraftsPage';
import ScheduleDraftModal from './ScheduleDraftModal';

export const components = {
    DraftsDropdown: DraftsDropdown,
    DraftsList: DraftsList,
    DraftsPage: DraftsPage,
    ScheduleDraftModal: ScheduleDraftModal,
};
